import React from "react";
import { useServices } from "../../contexts/ServiceContext";

interface Props {
    width: number;
    height: number;
    fill: string;
}

export const SubmittedCheckmarkIcon: React.FC<Props> = ({ width, height, fill }) => {
    const { edgeDeploy } = useServices();
    return (
        <svg
            height={`${height}px`}
            viewBox="0 0 24 24"
            width={`${width}px`}
            fill={fill}
            className={edgeDeploy ? "edgeCheckmark" : ""}
        >
            <path
                d="M21.8,10.7l-0.7-0.8c-0.4-0.4-0.5-1-0.5-1.5l0.1-1.1c0.1-1-0.6-1.9-1.5-2.1L18.1,5c-0.5-0.1-1-0.5-1.3-0.9L16.3,3
                c-0.5-0.9-1.6-1.2-2.5-0.8l-1,0.4c-0.5,0.2-1.1,0.2-1.6,0l-1-0.4c-0.9-0.4-2,0-2.5,0.8L7.1,3.9c-0.2,0.5-0.7,0.9-1.2,1L4.8,5.1
                c-1,0.2-1.6,1.1-1.6,2.1l0.1,1.1c0,0.5-0.1,1.1-0.5,1.5l-0.7,0.8c-0.7,0.8-0.7,1.9,0,2.6L2.8,14c0.4,0.4,0.5,1,0.5,1.5l-0.1,1.1
                c-0.1,1,0.6,1.9,1.5,2.1l1.1,0.2c0.5,0.1,1,0.5,1.3,0.9L7.7,21c0.5,0.9,1.6,1.2,2.5,0.8l1-0.4c0.5-0.2,1.1-0.2,1.6,0l1,0.4
                c0.9,0.4,2,0,2.5-0.8l0.6-0.9c0.3-0.5,0.7-0.8,1.3-0.9l1.1-0.2c1-0.2,1.6-1.1,1.5-2.1l-0.1-1.1c-0.1-0.5,0.1-1.1,0.5-1.5l0.7-0.8
                C22.5,12.6,22.5,11.4,21.8,10.7z M9.4,16L7,13.6c-0.4-0.4-0.4-1,0-1.4l0.1-0.1c0.4-0.4,1-0.4,1.4,0l1.6,1.6l5.2-5.2
                c0.4-0.4,1-0.4,1.4,0l0.1,0.1c0.4,0.4,0.4,1,0,1.4l-6,6C10.4,16.4,9.8,16.4,9.4,16z"
            />
        </svg>
    );
};
